import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
const SimilarsSkeleton = () => {
  if (PUBLIC_IS_BOT) return null;
  return <div className='pdp-container fit-left' data-sentry-component="SimilarsSkeleton" data-sentry-source-file="similars-skeleton.tsx">
            <div className='col-span-full mt-6 flex flex-col gap-5 overflow-hidden'>
                <div className='h-6 w-40 animate-pulse rounded-md bg-gray-100' />

                <div className='flex w-full gap-2'>
                    {Array(6).fill(undefined).map((_, index) => {
          return <div key={index} className='flex w-[164px] shrink-0 animate-pulse flex-col items-center justify-between rounded-md border border-border-gray-light bg-surface-solid-0 p-2 lg:w-56'>
                                    <div className='h-30 w-30 animate-pulse rounded bg-gray-100 lg:h-35 lg:w-35' />
                                    <div className='mt-1 h-5 w-full animate-pulse rounded bg-gray-100' />
                                    <div className='mt-1 h-10 w-full animate-pulse rounded bg-gray-100 lg:h-12' />
                                    <div className='mr-auto mt-2 h-10 w-4/5 animate-pulse rounded bg-gray-100 lg:h-12' />
                                </div>;
        })}
                </div>
            </div>
        </div>;
};
export default SimilarsSkeleton;